<template>
  <div>
    <div class="wraper">
      <div class="container-fluid mycontainer-fluid">
        <slot name="header"></slot>
        <div class="row myrow">
          <div class="col-xs-12 mycol header-title">
            <div class="col-xs-12 mycol">
              <div class="h-t-name pull-left">Вынесенные проекты</div>
            </div>
          </div>
        </div>
      </div>

      <div class="container-fluid mycontainer-fluid content content_table">
        <!--    Фильтры    -->
        <div class="wrapper-header">
          <form @submit.prevent="fetchSubmittedProjects">
            <div class="row myrow project-filter filter-wrapper-stl">
              <div
                class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder"
              >
                <input
                  id="filter_number"
                  type="text"
                  class="filter-input-stl"
                  placeholder="Номер проекта"
                  v-model="filter.number"
                />
              </div>
              <div
                class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder"
              >
                <input
                  id="filter_org_name"
                  type="text"
                  class="filter-input-stl"
                  placeholder="Организация"
                  v-model="filter.org_name"
                />
              </div>
              <div
                class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder"
              >
                <Multiselect
                  label="NAME"
                  class="i-main-style i-wid-100 stl-bs_bb multiselect-filter-project-register select-new-filter-style filter-select-stl"
                  track-by="ID"
                  v-model="filter.region"
                  :options="regionSupport"
                  :multiple="true"
                  placeholder="Регион"
                />
              </div>
              <div
                class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder"
              >
                <Multiselect
                  class="i-main-style i-wid-100 stl-bs_bb multiselect-filter-project-register select-new-filter-style filter-select-stl"
                  v-model="filter.date"
                  :options="years"
                  :multiple="true"
                  placeholder="Год рассмотрения"
                />
              </div>
              <div class="stl-df-ac" style="width: 394px;">
                <div
                  class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder"
                >
                  <button
                    type="button"
                    class="project-filter__butt-btn butt-new-style butt-new-style-reset stl-w-full"
                    @click="clearFilter"
                  >
                    СБРОС
                  </button>
                </div>

                <div
                  class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder"
                >
                  <button
                    class="project-filter__butt-btn butt-new-style stl-w-full"
                    type="submit"
                    @click="fetchSubmittedProjects"
                  >
                    Применить
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>

        <!--    Таблица    -->
        <div class="table-responsive container-stl">
          <table class="table table-hover table-striped table-new-style">
            <thead>
              <tr>
                <th class="text-nowrap">
                  №
                  <a
                    @click="setOrder('PROJECT_INFO_NUMBER')"
                    class="sort"
                    :class="{
                      desc:
                        sortColumn === 'PROJECT_INFO_NUMBER' &&
                        sortOrder === 'DESC'
                    }"
                  />
                </th>
                <th class="text-nowrap">
                  Заявитель
                  <a
                    @click="setOrder('COMPANY_NAME')"
                    class="sort"
                    :class="{
                      desc:
                        sortColumn === 'COMPANY_NAME' && sortOrder === 'DESC'
                    }"
                  />
                </th>
                <th class="text-nowrap">
                  Программа
                  <a
                    @click="setOrder('PROGRAM_NAME')"
                    class="sort"
                    :class="{
                      desc:
                        sortColumn === 'PROGRAM_NAME' && sortOrder === 'DESC'
                    }"
                  />
                </th>
                <th class="text-nowrap">
                  Название проекта
                  <a
                    @click="setOrder('PROJECT_INFO_NAME')"
                    class="sort"
                    :class="{
                      desc:
                        sortColumn === 'PROJECT_INFO_NAME' &&
                        sortOrder === 'DESC'
                    }"
                  />
                </th>
                <th class="text-nowrap">
                  Регион
                  <a
                    @click="setOrder('REGION_NAME')"
                    class="sort"
                    :class="{
                      desc: sortColumn === 'REGION_NAME' && sortOrder === 'DESC'
                    }"
                  />
                </th>
                <th class="text-nowrap">
                  Сумма займа, тыс. руб
                  <a
                    @click="setOrder('PROJECT_INFO_UF_SUM_REQUEST')"
                    class="sort"
                    :class="{
                      desc:
                        sortColumn === 'PROJECT_INFO_UF_SUM_REQUEST' &&
                        sortOrder === 'DESC'
                    }"
                  />
                </th>
                <th class="text-nowrap">
                  Тип вынесения
                  <a
                    @click="setOrder('MAKING_NAME')"
                    class="sort"
                    :class="{
                      desc: sortColumn === 'MAKING_NAME' && sortOrder === 'DESC'
                    }"
                  />
                </th>
                <th class="text-nowrap">
                  Номер ЭС
                  <a
                    @click="setOrder('ES_NUMBER')"
                    class="sort"
                    :class="{
                      desc: sortColumn === 'ES_NUMBER' && sortOrder === 'DESC'
                    }"
                  />
                </th>
                <th class="text-nowrap">
                  Дата ЭС
                  <a
                    @click="setOrder('ES_UF_DATE_SOVET')"
                    class="sort"
                    :class="{
                      desc:
                        sortColumn === 'ES_UF_DATE_SOVET' &&
                        sortOrder === 'DESC'
                    }"
                  />
                </th>
                <th class="text-nowrap">
                  Решение ЭС
                </th>
              </tr>
            </thead>

            <tbody v-if="submittedProjects.counts">
              <tr
                class="new"
                unselectable="on"
                v-for="project in submittedProjects.items"
                :key="project.ID"
                style="cursor: default"
              >
                <td>{{ project.PROJECT.UF_NUMBER }}</td>
                <td>{{ project.COMPANY.COMPANY_NAME }}</td>
                <td>{{ project.PROJECT.PROGRAM_NAME }}</td>
                <td>
                  <router-link
                    :to="{
                      name: 'ProjectEdit',
                      params: { id: project.UF_PROJECT_ID }
                    }"
                    style="color: #002333; text-decoration-line: underline;"
                  >
                    {{ project.PROJECT.UF_NAME }}
                  </router-link>
                </td>
                <td>{{ project.PROJECT.REGION_NAME }}</td>
                <td>{{ project.PROJECT.UF_SUM_REQUEST | toCurrency }}</td>
                <td>
                  <router-link
                    :to="{
                      name: 'Questions',
                      params: { id: project.ES.ID, projectId: project.ID }
                    }"
                    style="color: #002333; text-decoration-line: underline;"
                  >
                    {{ project.PROJECT.MAKING_NAME }}
                  </router-link>
                </td>
                <td>
                  <router-link
                    :to="{
                      name: 'EAList',
                      params: { id: project.ES.ID }
                    }"
                    style="color: #002333; text-decoration-line: underline;"
                  >
                    {{ project.ES.UF_NUMBER }}
                  </router-link>
                </td>
                <td>{{ project.ES.UF_DATE_SOVET }}</td>
                <td>
                  <button
                    v-if="project.ES.LINK"
                    class="project-filter__butt-btn butt-new-style stl-w-full"
                    type="button"
                    @click="link(project.ES.LINK)"
                  >
                    Скачать
                  </button>
                </td>
              </tr>
            </tbody>

            <tbody v-else>
              <tr>
                <td colspan="6">Проекты не найдены</td>
              </tr>
            </tbody>

            <tfoot>
              <tr>
                <td colspan="10">
                  <div class="paging">
                    <div class="container-fluid">
                      <div class="row">
                        <div class="col-xs-6 mycol">
                          <Pagination
                            :pages="pages"
                            :currentPage.sync="currentPage"
                          />
                        </div>
                        <div class="col-xs-6 mycol">
                          <div class="pull-right page-total">
                            <span style="padding-right: 15px">
                              Всего: {{ submittedProjects.counts }}
                            </span>
                            <span>Выводить по</span>
                            <span>
                              <select
                                class="page-select"
                                v-model="itemsPerPage"
                              >
                                <option value="20">20</option>
                                <option value="40">40</option>
                                <option value="100">100</option>
                                <option value="500">500</option>
                              </select>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
    <slot name="footer"></slot>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import { mapGetters } from "vuex";
import Vue from "vue";
import {
  SET_MAIN_MENU,
  FETCH_DIRECTORIES,
  SET_IS_VIEW_ALL_EXPERTISE,
  FETCH_SUBMITTED
} from "@/store/actions.type";
import { ProjectsService } from "@/common/api.service";
import Multiselect from "vue-multiselect";
import Support from "../Support.vue";

Vue.filter("toCurrency", function(value) {
  if (typeof value !== "number") {
    return value;
  }
  var formatter = new Intl.NumberFormat("ru-RU", {
    style: "decimal",
    minimumFractionDigits: 0
  });
  return formatter.format(value);
});

export default {
  name: "SubmittedProjects",
  title: "Вынесенные проекты",
  components: {
    Support,
    Pagination,
    Multiselect
  },
  data() {
    return {
      filter: {
        number: "",
        org_name: "",
        region: [],
        date: []
      },
      currentYear: new Date().getFullYear(),
      itemsPerPage: 20,
      currentPage: 1,
      sortOrder: "",
      sortColumn: ""
    };
  },

  mounted() {
    this.$store.dispatch(SET_MAIN_MENU, []);
    if (this.currentUser.TYPE_USER === "manager") {
      ProjectsService.getManagerRoleDefaultSetting().then(({ data }) => {
        this.$store.dispatch(
          SET_IS_VIEW_ALL_EXPERTISE,
          data.IS_VIEW_ALL_EXPERTISE
        );
        let navMainMenu = [];
        if (data.START_PAGE === "REESTR_PROJECTS") {
          if (data.IS_REESTR_PROJECTS) {
            navMainMenu.push({
              name: "Реестр проектов",
              route: "Projects"
            });
          }
          if (data.IS_REESTR_EXPERTISE) {
            navMainMenu.push({
              name: "Реестр экспертиз",
              route: "Expertise"
            });
          }
          if (data.IS_VIEW_SUBMITTED_PROJECTS) {
            navMainMenu.push({
              name: "Вынесенные проекты",
              route: "SubmittedProjects"
            });
          }
          if (data.IS_VIEW_ADMIN_MODULE) {
            navMainMenu.push({
              name: "Администрирование",
              route: "Administration"
            });
          }
        } else {
          if (data.IS_REESTR_PROJECTS) {
            navMainMenu.push({
              name: "Реестр проектов",
              route: "Projects"
            });
          }
          if (data.IS_REESTR_EXPERTISE) {
            navMainMenu.push({
              name: "Реестр экспертиз",
              route: "Expertise"
            });
          }
          if (
            this.currentUser.ACTIVE_ROLE == 36 ||
            this.currentUser.ACTIVE_ROLE == 37
          ) {
            navMainMenu.push({
              name: "Заседания",
              route: "Conference"
            });
          }
          if (data.IS_VIEW_SUBMITTED_PROJECTS) {
            navMainMenu.push({
              name: "Вынесенные проекты",
              route: "SubmittedProjects"
            });
          }
        }
        this.$store.dispatch(SET_MAIN_MENU, navMainMenu);
      });
    } else {
      this.$store.dispatch(SET_MAIN_MENU, [
        {
          name:
            this.currentUser.TYPE_USER === "manager"
              ? "Реестр проектов"
              : "Мои проекты",
          route: "Projects"
        }
      ]);
    }

    this.$store.dispatch(FETCH_DIRECTORIES, ["status", "regions"]);

    this.fetchSubmittedProjects();
  },

  computed: {
    ...mapGetters([
      "submittedProjects",
      "iSubmittedProjectsLoading",
      "DRegions",
      "currentUser",
      "directory"
    ]),
    regionSupport() {
      let ret = [];
      let f = JSON.stringify(this.DRegions);
      ret = JSON.parse(f);
      ret.unshift({ ID: 0, NAME: "Все" });
      return ret;
    },
    years() {
      const startYear = 2015;
      const yearsArray = [];
      for (let year = startYear; year <= this.currentYear; year++) {
        yearsArray.push(year);
      }
      return yearsArray;
    },
    listConfig() {
      const q = {
        page: this.currentPage,
        limit: this.itemsPerPage,
        filter: {}
      };
      if (this.filter.number !== "") {
        q.filter.UF_NUMBER = this.filter.number;
      }
      if (this.filter.org_name !== "") {
        q.filter.COMPANY_NAME = this.filter.org_name;
      }
      if (this.filter.region.length) {
        q.filter.REGION_ID = [];
        this.filter.region.forEach(function(it) {
          if (it.ID > 0) {
            q.filter.REGION_ID.push(it.ID);
          }
        }, this);
      }
      if (this.filter.date.length) {
        q.filter.DATE_SOVET_YEAR = [];
        this.filter.date.forEach(function(it) {
          console.log("it", it);
          q.filter.DATE_SOVET_YEAR.push(it);
        }, this);
      }
      if (this.sortColumn !== "") {
        let sort = {
          column: "",
          order: ""
        };
        sort.column = this.sortColumn;
        sort.order = this.sortOrder;
        q.sort = sort;
      }
      return q;
    },
    pages() {
      if (
        this.iSubmittedProjectsLoading ||
        this.submittedProjects.counts <= this.itemsPerPage
      ) {
        return [];
      }
      return [
        ...Array(
          Math.ceil(this.submittedProjects.counts / this.itemsPerPage)
        ).keys()
      ].map(e => e + 1);
    }
  },

  watch: {
    currentPage(newValue) {
      this.listConfig.page = newValue;
      this.fetchSubmittedProjects();
    },
    itemsPerPage(newValue) {
      this.listConfig.limit = newValue;
      this.fetchSubmittedProjects();
    }
  },

  methods: {
    fetchSubmittedProjects() {
      this.$store.dispatch(FETCH_SUBMITTED, this.listConfig);
    },

    setOrder(column) {
      if (this.sortColumn !== column) {
        this.sortOrder = "ASC";
      } else {
        if (this.sortOrder === "DESC") {
          this.sortOrder = "ASC";
        } else {
          this.sortOrder = "DESC";
        }
      }
      this.sortColumn = column;
      this.fetchSubmittedProjects();
    },

    clearFilter() {
      this.filter = {
        number: "",
        org_name: "",
        region: [],
        date: []
      };
      this.fetchSubmittedProjects();
    },

    link(url) {
      window.open(url, "_blank");
    }
  }
};
</script>
